<script setup>
import { onMounted, ref, defineProps, defineEmits } from 'vue';
import { useFelixBagAuxStore, useVideobotContentStore, useGlobalStateStore } from '../../../../store';
import TextContent from './TextContent.vue';
import PdfContent from './PdfContent.vue';
import VideoContent from './VideoContent.vue';
import CarouselContent from './CarouselContent.vue';

defineEmits(["close-submenu"])

const felixBagAuxStore = useFelixBagAuxStore();
const videobotContent = useVideobotContentStore();
const felixBagGlobalStore = useGlobalStateStore();
const typeContent = ref('')
const contentCarrossel = ref(null)

const props = defineProps(['id'])
const items = ref([])
const selectedItem = ref(null)
const itemsFiltered = ref([])

onMounted(() => {
  felixBagAuxStore.pauseAfter(1000)
  // audio.src = "//overmediacast-videos-sp.s3.sa-east-1.amazonaws.com/videobot/vivo/audios_parametrizados/Trilha+de+cuidados.mp3"
  items.value = { ...videobotContent.videobotContent[props.id.id] }
  itemsFiltered.value = { ...filterCarousels() }
});

function filterCarousels() {
  const itensFiltered = { ...items.value }
  for (const itemName in itensFiltered) {
    itensFiltered[itemName].key = itemName;
    if (itemName.includes("carrossel_") && !itemName.includes("_01")) {
      delete itensFiltered[itemName]
    }
  }
  return itensFiltered
}


function openContent(item) {
  if (props.id.id === 'links_uteis') {
    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging'){
      if (item.content.length > 100) {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = item.content
        const href = tempElement.querySelector('span').textContent
        window.open(href, '_blank');
      } else {
        let linkUrl = item.content;
        window.open(linkUrl, '_blank');
      }
    } else {
      if (item.content.length > 100) {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = item.content
        const href = tempElement.querySelector('a').textContent
        window.open(href, '_blank');
      } else {
        let linkUrl = item.content;
        window.open(linkUrl, '_blank');
      }
    }
    
  } else if (item.key && item.key.includes("carrossel_")) {
    typeContent.value = 'carrossel'
    let auxKey = item.key.replace("carrossel_", "")
    auxKey = auxKey.replace("_01", "")
    contentCarrossel.value = {
      type: item.type,
      title: item.title,
      content: []
    }
    for (const key in items.value) {
      if (key.includes(auxKey)) {
        contentCarrossel.value.content.push(items.value[key].content)
      }
    }
    console.log("Carrossel aqui olha: ", contentCarrossel)

  } else {
    typeContent.value = item.type
    item.viewed = true;
    selectedItem.value = item
  }

  seeContent(item.key)
}

function seeContent(key) {
  felixBagGlobalStore.setViewContent(props.id.id, key);
}

</script>

<template>
  <div id="trilha-de-cuidado">
    <div class="header">
      <div style="display: flex; flex-direction: column; align-items: start; width: 60%;">
        <v-btn
          @click="$emit('close-submenu');"
          variant="text" color="inherit"><img
            src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/642712b9-7c61-4e25-87b0-5b7aefc49d67.svg"
            alt=""></v-btn>
        <p class="submenu-title">{{ props.id.title }}</p>
      </div>


      <img style="width: 40%;"
        src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/51990468-49c0-4d27-a166-de69bf5fbb54.svg"
        alt="">

    </div>

    <v-card variant="flat" class="mx-auto" max-width="300" style="margin-top: 5%; overflow: hidden; overflow-y: auto;
    height: 60%">
      <v-list>
        <v-list-item class="jb-save" :data-source="item.key" height="60px" @click="openContent(item)" v-for="(item, i) in itemsFiltered" :key="i" :value="item">
          <template v-slot:prepend>
            <div class="icon-wrapper" v-if="item.type == 'text'">
              <img style="width: 20px;"
                src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/10d4affa-0770-43f1-8fa5-7561f064e83d.svg"
                alt="">
            </div>
            <div class="icon-wrapper" v-if="item.type == 'pdf' || item.type == 'image'">
              <img style="width: 20px;"
                src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/eb6a15ba-b883-4fdc-ab58-424c45287fb1.svg"
                alt="">
            </div>
            <div class="icon-wrapper" v-if="item.type == 'video' || item.type == 'youtube'">
              <img style="width: 20px;"
                src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/eb6a15ba-b883-4fdc-ab58-424c45287fb1.svg"
                alt="">
            </div>

            <v-list-item-title style="margin-left: 20px; max-width: 150px; word-wrap: break-word; font-size: 14px;"
              v-text="item.title"></v-list-item-title>
          </template>

          <template v-slot:append>
            <img v-if="!felixBagGlobalStore.globalState.interactives.content.view[props.id.id].includes(i)" style="margin-right: 10px;"
              src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/3f0db893-ff35-49d3-aad8-d28b39d5e1cb.svg"
              alt="">
            <img
              src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/1b595908-3f7a-451d-aa09-30178d5456fd.svg"
              alt="">
          </template>
        </v-list-item>

      </v-list>
    </v-card>
  </div>

  <TextContent :item="selectedItem" @close-content="typeContent = ''" v-if="typeContent == 'text'" />
  <PdfContent :item="selectedItem" @close-content="typeContent = ''" v-if="typeContent == 'pdf'" />
  <VideoContent :item="selectedItem" @close-content="typeContent = ''"
    v-if="typeContent == 'video' || typeContent == 'youtube'" />
  <CarouselContent v-if="typeContent == 'carrossel'" @close-content="typeContent = ''" :item="contentCarrossel" />
</template>

<style scoped>
#trilha-de-cuidado {
  width: 100%;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 0;
  z-index: 1;
}

.header {
  height: 25%;
  background-color: #BC4AFF;
  display: flex;
}

.submenu-title {
  color: white;
  margin-top: 15px;
  font-size: 20px;
  text-align: start;
  margin-left: 20%;
}

.icon-wrapper {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F6E7FF;
  border-radius: 50%;
}
</style>